import {createUniversalContext} from "../UniversalContext";

export const FeatureFlagsContext = createUniversalContext({})